import { Component } from '@angular/core';

@Component({
  selector: 'inlite-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

}
